<div class="container mt-card" #origin>
    <div class="card mt-5">
        <div class="title m-3 mb-0">
            <h3>
                {{text}} Examination
            </h3>
        </div>

        <div class="container mb-3">
            <p class="text-muted p-1" *ngIf="text!=='View'">Please fill in the details below to {{text}} the
                examination.</p>
            <div class="mb-3 text-danger" *ngIf="modelError">
                <span *ngFor="let err of modelError" class="mr-5">{{err}}</span>
            </div>
            <div class="floating-icon" (click)="onEditClicked()" *ngIf="mode == 'view-all'">
                <mat-icon class="mat-icon-button icon-lg" svgIcon="mat:edit" title="Edit"></mat-icon>
            </div>
            <ul class="nav nav-tabs mb-3" id="examTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active bg-success text-white" id="tab0" data-bs-toggle="tab"
                        data-bs-target="#basicTab" type="button" role="tab">Basic Info</button>
                </li>
                <li [ngClass]="{ 'd-none': (exam.psychometricTest) }" class="nav-item" role="presentation">
                    <button class="nav-link " id="tab1" data-bs-toggle="tab" data-bs-target="#questionTab" type="button"
                        role="tab">Question Settings</button>
                </li>
                <li [ngClass]="{ 'd-none': !(exam.useQuestionBank && text === 'Create') }" class="nav-item"
                    role="presentation">
                    <button class="nav-link " id="tab2" data-bs-toggle="tab" data-bs-target="#questionBankTab"
                        type="button" role="tab">Question Bank Setup</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab3" data-bs-toggle="tab" data-bs-target="#securityTab" type="button"
                        role="tab">Security</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab4" data-bs-toggle="tab" data-bs-target="#instructionsTab"
                        type="button" role="tab">Instructions</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab5" data-bs-toggle="tab" data-bs-target="#othersTab" type="button"
                        role="tab">Others</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab6" data-bs-toggle="tab" data-bs-target="#scheduleTab" type="button"
                        role="tab">Schedule</button>
            </ul>
            <form #examForm="ngForm" (ngSubmit)="saveExam(examForm)">

                <div class="tab-content" id="tabContent">
                    <div class="tab-pane fade show active" id="basicTab" role="tabpanel">
                        <!-- Add your Basic Info form controls here -->
                        <!-- Basic Info fields -->
                        <div class="form-grid">
                            <div class="form-group">
                                <label for="examinationName">Examination Name</label>
                                <input id="examinationName" type="text" class="form-control"
                                    placeholder="Examination Name" required [(ngModel)]="exam.examinationName"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                            </div>

                            <div class="form-group">
                                <label for="session">Period</label> <label class="custom-control-label ml-1">
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="An identifier used to distinguish repeated examinations that have the same examination name, such as academic session, year, or cohort (e.g., 2025/2026 Session, 2026 Intake, Cohort A).">
                                    </i>
                                </label>
                                <input id="session" type="text" class="form-control" placeholder="Period" required
                                    [(ngModel)]="exam.session" [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll">
                            </div>

                            <div class="form-group" *ngIf="!exam.psychometricTest">
                                <label for="examinationType">Examination Type</label>
                                <ng-select id="examinationType" class="form-select" [(ngModel)]="exam.examinationType"
                                    required [ngModelOptions]="{ standalone: true }"
                                    (ngModelChange)="resetQuestionSelectionMode()" [disabled]="disableAll">
                                    <ng-option selected value="" disabled>Select Examination Type</ng-option>
                                    <ng-option value="NotSet">Not Set</ng-option>
                                    <ng-option value="MultipleChoice">Multiple Choice</ng-option>
                                    <ng-option value="Essay">Essay</ng-option>
                                    <ng-option value="SAQ">Short Answer Question</ng-option>
                                    <ng-option value="Interview">Interview</ng-option>
                                </ng-select>
                            </div>

                            <div class="form-group" *ngIf="!exam.psychometricTest">
                                <label for="duration">Duration (Minutes)
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Set to 0 for untimed exams. Otherwise, enter the exam duration in minutes.">
                                    </i>
                                </label>
                                <input id="duration" type="number" min="0" class="form-control" placeholder="Duration"
                                    required [(ngModel)]="exam.duration" [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll">
                            </div>
                            <div class="form-group" *ngIf="!exam.psychometricTest">
                                <label for="numberOfQuestions">Number of Questions</label>
                                <input id="numberOfQuestions" type="number" min="0" class="form-control"
                                    placeholder="Number of Questions" required [(ngModel)]="exam.numberOfQuestions"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                            </div>

                            <div class="form-group" *ngIf="exam.examinationType === 'Essay'  && !exam.psychometricTest">
                                <label for="maximumNumberOfEssayAnswers">Maximum Number of Answers <i
                                        class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Sets the maximum number of questions a candidate can answer. Use 0 for no limit."></i></label>
                                <input id="maximumNumberOfEssayAnswers" type="number" min="0" class="form-control"
                                    placeholder="Maximum Number of Essay Answers"
                                    [(ngModel)]="exam.maximumNumberOfEssayAnswers"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                            </div>

                            <div class="form-group" *ngIf="exam.examinationType === 'SAQ' && !exam.psychometricTest">
                                <label for="maximumNumberOfSAQAnswers">Maximum Number of Answers <i
                                        class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Sets the maximum number of questions a candidate can answer. Use 0 for no limit."></i></label>
                                <input id="maximumNumberOfSAQAnswers" type="number" min="0" class="form-control"
                                    placeholder="Maximum Number of SAQ Answers"
                                    [(ngModel)]="exam.maximumNumberOfSAQAnswers" [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll">
                            </div>

                            <div class="form-group" *ngIf="!exam.psychometricTest">
                                <label for="questionSelectionMode" class="label-with-info">
                                    Question Mode
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Controls how questions are selected for candidates. Some modes randomize questions to reduce cheating."></i>
                                </label>
                                <ng-select id="questionSelectionMode" class="form-select"
                                    [(ngModel)]="exam.questionSelectionMode" required
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <ng-option selected value="" disabled>Select Question Mode</ng-option>
                                    <ng-option value="All">All</ng-option>
                                    <ng-option *ngIf="exam.examinationType !== 'Essay'"
                                        value="Random">Random</ng-option>
                                    <ng-option value="RandomPerQuestionNumber">Random Per Question Number</ng-option>
                                    <ng-option *ngIf="exam.examinationType !== 'Essay'" value="RandomPerCategory">
                                        Random Per Category</ng-option>
                                    <ng-option *ngIf="exam.examinationType !== 'Essay'"
                                        value="RandomPerCandidateCategory">
                                        Random Per Candidate Category</ng-option>
                                </ng-select>
                            </div>
                            <div class="form-group" *ngIf="!exam.psychometricTest && exam.questionSelectionMode === 'RandomPerCategory'">
                                <label for="numberofQuestionsPerCategory">Number Questions Per Category</label>
                                <input id="numberofQuestionsPerCategory" type="number" min="0" class="form-control"
                                    placeholder="0" required [(ngModel)]="exam.numberofQuestionsPerCategory"
                                    [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll || exam.questionSelectionMode!=='RandomPerCategory'" />
                            </div>
                            <div class="form-group">
                                <label for="calculatorType">Calculator Type</label>
                                <ng-select id="calculatorType" class="form-select" [(ngModel)]="exam.calculatorType"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <ng-option value="None" selected="selected">None</ng-option>
                                    <ng-option value="Simple">Simple</ng-option>
                                    <ng-option value="Scientific">Scientific</ng-option>
                                </ng-select>
                            </div>
                            <div class="form-group">
                                <label for="examStartDate">Start Date</label>
                                <input id="examStartDate" type="datetime-local" class="form-control"
                                    placeholder="Start Date" required data-date-format="DD MMMM YYYY"
                                    [(ngModel)]="exam.examStartDate" [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll">
                            </div>
                            <div class="form-group">
                                <label for="examEndDate">End Date</label>
                                <input id="examEndDate" type="datetime-local" class="form-control"
                                    placeholder="End Date" required [(ngModel)]="exam.examEndDate"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                            </div>

                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="liveProctoring" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.liveProctoring" [ngModelOptions]="{ standalone: true }"
                                        (change)="onProctorChange()" [disabled]="disableAll">
                                    <label class="custom-control-label" for="liveProctoring">
                                        Live Proctoring
                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Enables real-time human monitoring of candidates throughout the exam. Requires active proctor availability.">
                                        </i>
                                    </label>
                                </div>
                            </div>
                            <!-- <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="aIProctoring" type="checkbox" class="custom-control-input"
                                        (change)="onProctorChange()" [(ngModel)]="exam.aIProctoring"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="aIProctoring">
                                        AI Proctoring
                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Uses automated AI monitoring to detect suspicious behavior without a live human proctor.">
                                        </i>
                                    </label>
                                </div>
                            </div> -->
                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="facialRecognition" type="checkbox" class="custom-control-input"
                                        (change)="onProctorChange()" [(ngModel)]="exam.facialRecognition"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="facialRecognition">
                                        Facial Recognition
                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Verifies candidate identity using facial recognition before and during the exam session.">
                                        </i></label>
                                </div>
                            </div>
                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="recording" type="checkbox" class="custom-control-input"
                                        (change)="onProctorChange(true)" [(ngModel)]="exam.recording"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="recording">
                                        Recording
                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Records video, audio, and screen activity during the exam for review, audit, and incident investigation.">
                                        </i>
                                    </label>


                                </div>
                            </div>
                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="passportMandatory" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.passportMandatory" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="passportMandatory">Make Candidate Picture
                                        Mandatory</label>
                                </div>
                            </div>
                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="useSEB" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.useSEB" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="useSEB">
                                        Use SEB (Safe Exam Browser)

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Locks down the candidate’s device to prevent access to other applications, websites, or screen capture tools."></i>

                                    </label>
                                </div>
                            </div>
                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="requireSecondView" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.requireSecondView" (click)="requireSecondViewCicked($event)"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="requireSecondView">
                                        Require Second View

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Requires candidates to connect a second camera (usually a phone) to monitor their environment during the exam."></i>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="psychometricTest" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.psychometricTest" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll || this.text === 'Update'"
                                        (ngModelChange)="onPsychometricTestChange()">
                                    <label class="custom-control-label" for="psychometricTest">Psychometric Test</label>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end mt-3">
                            <button type="button" class="btn btn-lg btn-primary"
                                (click)="nextTab(exam.psychometricTest ? this.text === 'Update' ? 2 : 1 : 0)">Next</button>
                        </div>
                    </div>
                    <div *ngIf="!exam.psychometricTest" class="tab-pane fade" id="questionTab" role="tabpanel">
                        <!-- Question Settings -->
                        <div class="form-grid">

                            <div class="form-group" style="display: contents;margin-top: 20px;"
                                *ngIf="!exam.psychometricTest">
                                <div class="custom-control custom-checkbox">
                                    <input id="randomiseOptions" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.randomiseOptions" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll || exam.psychometricTest">
                                    <label class="custom-control-label" for="randomiseOptions">
                                        Randomise Options

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Randomizes the order of answer options for each candidate to reduce collusion and pattern memorization.">
                                        </i>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group" style="display: contents;margin-top: 20px;"
                                *ngIf="!exam.psychometricTest">
                                <div class="custom-control custom-checkbox">
                                    <input id="useQuestionBank" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.useQuestionBank" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll || exam.psychometricTest"
                                        (ngModelChange)="onUseQuestionBankChange()">
                                    <label class="custom-control-label" for="useQuestionBank">
                                        Use Question Bank

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Pulls questions dynamically from the question bank instead of a fixed exam set. This allows for varied exams and reduces cheating.">
                                        </i>
                                    </label>
                                </div>
                            </div>

                            <!-- note: This is a placeholder for essay marking options, which can be uncommented if needed -->
                            <!-- <div class="form-group" style="display: contents;margin-top: 20px;">
                                                            <div class="custom-control custom-checkbox">
                                                                <input id="sectionalizedEssayMarking" type="checkbox" class="custom-control-input"
                                                                    [(ngModel)]="exam.sectionalizedEssayMarking"
                                                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                                                <label class="custom-control-label" for="sectionalizedEssayMarking">Sectionalized
                                                                    Essay Marking</label>
                                                            </div>
                                                        </div> -->
                        </div>
                        <div *ngIf="text == 'Create' && !exam.useQuestionBank">
                            <div class="d-flex align-items-sm-end mb-2 text-muted">
                                <div class="d-flex">
                                    <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:error_outline"></mat-icon>
                                    <span class=" pb-0 ml-1">
                                        Skip this section if you want to add questions later
                                    </span>
                                </div>
                            </div>

                            <div class="form-grid">

                                <div class="form-group">
                                    <label for="candidateFile">Question File</label>
                                    <input type="file" class="form-control file-select"
                                        (change)="onQuestionFileChange($event)" [disabled]="exam.useQuestionBank" />
                                </div>

                                <div class="form-group">
                                    <label class="">Question Format</label>
                                    <ng-select class="form-select" [(ngModel)]="exam.questionFormat"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="exam.useQuestionBank">
                                        <ng-option selected value="" disabled>Select Format</ng-option>
                                        <ng-option value="Format1">Format1</ng-option>
                                        <ng-option value="Format2">Format2</ng-option>
                                        <ng-option value="None">Excel</ng-option>
                                    </ng-select>
                                </div>
                                <div class="form-group" style="display: contents;margin-top: 20px;">
                                    <div class="custom-control custom-checkbox">
                                        <input id="useRawHTML" type="checkbox" class="custom-control-input"
                                            [(ngModel)]="exam.useRawHTML" [ngModelOptions]="{ standalone: true }"
                                            [disabled]="exam.useQuestionBank">
                                        <label class="custom-control-label" for="useRawHTML">Use Raw HTML</label>
                                    </div>
                                </div>



                            </div>
                            <div class="d-flex align-content-between justify-content-between mt-2"
                                *ngIf="!exam.useQuestionBank">
                                <a href="/assets/templates/Question_Upload_Format_1.txt" download>
                                    Download Template Format 1</a>
                                <a href="/assets/templates/Question_Upload_Format_2.txt" download>
                                    Download Template Format 2</a>

                                <a href="/assets/templates/Question Format.xlsx" download>
                                    Download Template Excel</a>
                            </div>

                        </div>

                        <div class="d-flex justify-content-between mt-3">
                            <button type="button" class="btn btn-lg btn-secondary"
                                (click)="prevTab(1)">Previous</button>
                            <button type="submit" class="btn btn-lg btn-success" *ngIf="text=='Update'">Submit</button>
                            <button type="button" class="btn btn-lg btn-primary"
                                (click)="nextTab(exam.useQuestionBank && text === 'Create' ? 1 : 2)">Next</button>
                        </div>
                    </div>
                    <div *ngIf="exam.useQuestionBank && text === 'Create'" class="tab-pane fade" id="questionBankTab"
                        role="tabpanel">
                        <div class="question-bank-section">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="question-bank-header">
                                    Question Banks
                                </div>
                                <div class="form-group" style="display: contents;margin-top: 20px;">
                                    <div class="custom-control custom-checkbox" *ngIf="!exam.psychometricTest">
                                        <input id="showWebTestQuestionBank" type="checkbox" class="custom-control-input"
                                            [(ngModel)]="showWebTestQuestionBank"
                                            [ngModelOptions]="{ standalone: true }" [disabled]="disableAll"
                                            (change)="onShowWebTestQuestionBankChange()">
                                        <label class="custom-control-label" for="showWebTestQuestionBank">Show
                                            WebTest Question Banks</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <!-- Normal exam note -->
                            <div class="alert alert-info mt-3 py-1 px-2 small d-flex align-items-center"
                                *ngIf="!exam.psychometricTest">
                                <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:error_outline"></mat-icon>
                                <strong>Note:</strong> Maximum pool size is 1,000 per question bank.
                            </div>

                            <!-- Psychometric-only note -->
                            <div class="alert alert-warning mt-3 py-1 px-2 small d-flex align-items-center"
                                *ngIf="exam.psychometricTest">
                                <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:error_outline"></mat-icon>
                                <strong>Important:</strong> Only one question bank is allowed for psychometric
                                exams.
                            </div>
                        </div>

                        <div id="questionBankTable" class="table-responsive mt-3">
                            <table class="table table-sm table-bordered align-middle">
                                <thead class="table-light">
                                    <tr>
                                        <th style="width: 40px;">
                                            <input type="checkbox" (change)="toggleAllQuestionBanks($event)"
                                                [disabled]="exam.psychometricTest">
                                        </th>
                                        <th>Question Bank Name</th>
                                        <th *ngIf="!exam.psychometricTest">Category</th>
                                        <th>Total Questions</th>
                                        <th>Source</th>
                                        <ng-container *ngIf="!exam.psychometricTest">
                                            <th style="width: 150px;">Pool Size</th>
                                            <th style="width: 150px;">No. of Questions</th>
                                        </ng-container>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let bank of questionBanks; let i = index">
                                        <td>
                                            <input type="checkbox" [(ngModel)]="bank.selected"
                                                [ngModelOptions]="{ standalone: true }"
                                                (change)="onBankSelectionChange(bank)"
                                                [disabled]="exam.psychometricTest && !bank.selected && selectedPsychometricBankCount >= 1">
                                        </td>
                                        <td>{{ bank.name }}</td>
                                        <td *ngIf="!exam.psychometricTest">{{ bank.category ? bank.category : '--' }}
                                        </td>
                                        <td>{{ bank.isWebTestBank && !exam.psychometricTest ? '--' :
                                            bank.totalNumberOfQuestions}}</td>
                                        <td>{{ bank.isWebTestBank ? 'WebTest' : 'Own' }}</td>
                                        <ng-container *ngIf="!exam.psychometricTest">
                                            <td>
                                                <input type="number" class="form-control form-control-sm"
                                                    [(ngModel)]="bank.questionBankPoolSize"
                                                    [ngModelOptions]="{ standalone: true }" [required]="bank.selected"
                                                    [disabled]="!bank.selected" min="0" max="1000"
                                                    (ngModelChange)="onPoolSizeChange($event, bank)">
                                            </td>
                                            <td>
                                                <input type="number" class="form-control form-control-sm"
                                                    [(ngModel)]="bank.numberOfQuestions"
                                                    [ngModelOptions]="{ standalone: true }" [required]="bank.selected"
                                                    [disabled]="!bank.selected" min="0" [max]="getMaxQuestions(bank)"
                                                    (ngModelChange)="onNoOfQuestionsChange($event, bank)">
                                            </td>
                                        </ng-container>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="d-flex justify-content-between mt-3">
                            <button type="button" class="btn btn-lg btn-secondary"
                                (click)="prevTab(exam.psychometricTest ? 1 : 2)">Previous</button>
                            <button type="button" class="btn btn-lg btn-primary" (click)="nextTab(2)">Next</button>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="securityTab" role="tabpanel">
                        <!-- Security Settings -->
                        <div class="form-grid">

                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="detectFocusLoss" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.detectFocusLoss" [ngModelOptions]="{ standalone: true }"
                                        (click)="detectFocusClicked($event)" [disabled]="disableAll">
                                    <label class="custom-control-label" for="detectFocusLoss">
                                        Detect Focus Loss

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Monitors when a candidate switches tabs, applications, or windows during the exam.">
                                        </i>

                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="lossOfFocusAction" class="label-with-info">
                                    Loss of Focus Action

                                </label>
                                <label class="ml-1">
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Defines the system action taken when focus loss exceeds the allowed threshold.">
                                    </i>
                                </label>
                                <ng-select id="lossOfFocusAction" class="form-select" (change)="focusChange()"
                                    [(ngModel)]="exam.lossOfFocusAction" [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll || !exam.detectFocusLoss">
                                    <ng-option value="NotSet" selected="selected">Not Set</ng-option>
                                    <ng-option value="Disqualify">Disqualify</ng-option>
                                    <ng-option value="RestartExam">Restart Exam</ng-option>
                                    <ng-option value="EndExam">End Exam</ng-option>
                                    <ng-option value="ReduceTime">Reduce Exam Time</ng-option>
                                </ng-select>
                            </div>
                            <div class="form-group">
                                <label for="permissibleDurationOfLoss" class="label-with-info">
                                    Permissible Duration of Focus Loss (Seconds)

                                </label>
                                <label class="ml-1">
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Maximum time a candidate is allowed to be out of focus before an enforcement action is triggered.">
                                    </i>

                                </label>

                                <input id="permissibleDurationOfLoss" type="number" min="0" class="form-control"
                                    placeholder="Permissible Duration" [(ngModel)]="exam.permissibleDurationOfLoss"
                                    [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll || !exam.detectFocusLoss">
                            </div>

                            <div class="form-group">
                                <label for="noOfTimesAllowedForFocusLoss" class="label-with-info">
                                    Number of Times Allowed for Focus Loss

                                </label>
                                <label class="ml-1">
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="How many focus-loss incidents are tolerated before penalties are applied.">
                                    </i>

                                </label>
                                <input id="noOfTimesAllowedForFocusLoss" type="number" min="0" class="form-control"
                                    placeholder="Focus Loss Count" [(ngModel)]="exam.noOfTimesAllowedForFocusLoss"
                                    [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll || !exam.detectFocusLoss">
                            </div>

                            <div class="form-group">
                                <label for="lossofFocusReduceTimeActionDuration" class="label-with-info">
                                    Loss of Focus Reduce Time Action Duration (Seconds)

                                </label><label class="ml-1">
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Amount of exam time deducted when the Reduce Time action is triggered.">
                                    </i>
                                </label>

                                <input id="lossofFocusReduceTimeActionDuration" type="number" min="0"
                                    class="form-control" placeholder="Reduce Time Duration"
                                    [(ngModel)]="exam.lossofFocusReduceTimeActionDuration"
                                    [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll || exam.lossOfFocusAction !== 'ReduceTime'">
                            </div>

                            <div class="form-group">
                                <label for="lossofFocusRestartActionLimit" class="label-with-info">
                                    Loss of Focus Restart Action Limit

                                </label><label class="ml-1">
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Maximum number of times the exam can be restarted due to focus loss before escalation.">
                                    </i>
                                </label>
                                <input id="lossofFocusRestartActionLimit" type="number" min="0" class="form-control"
                                    placeholder="Restart Action Limit" [(ngModel)]="exam.lossofFocusRestartActionLimit"
                                    [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll || !exam.detectFocusLoss || exam.lossOfFocusAction !== 'RestartExam'">
                            </div>
                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="allowExamRetake" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.allowExamRetake" [ngModelOptions]="{ standalone: true }"
                                        (click)="examRetakeClicked($event)" [disabled]="disableAll">
                                    <label class="custom-control-label" for="allowExamRetake">
                                        Allow Exam Retake

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Allows candidates to retake the exam based on configured limits and completion conditions.">
                                        </i>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="maxRetake" class="label-with-info">
                                    Max Retake

                                </label>
                                <label class="ml-1">
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Maximum number of times a candidate is permitted to retake this exam.">
                                    </i>
                                </label>
                                <input id="maxRetake" type="number" min="0" class="form-control"
                                    placeholder="Max Retake" [(ngModel)]="exam.maxRetake"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                            </div>

                            <div class="form-group">
                                <label for="answeredQuestionsPercentage" class="label-with-info">
                                    Maximum Percentage for Answered Questions

                                </label>
                                <label class="ml-1">
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Limits retakes to candidates who have not answered beyond this percentage of questions.">
                                    </i>
                                </label>

                                <input id="answeredQuestionsPercentage" type="number" min="0" class="form-control"
                                    placeholder="Maximum Percentage For Answered Questions"
                                    [(ngModel)]="exam.answeredQuestionsPercentage"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                            </div>

                            <div class="form-group">
                                <label for="examinationDurationPercentage" class="label-with-info">
                                    Maximum Percentage for Examination Duration

                                </label>
                                <label class="ml-1">
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Restricts retakes if a candidate has already consumed more than this percentage of exam time.">
                                    </i>
                                </label>

                                <input id="examinationDurationPercentage" type="number" min="0" class="form-control"
                                    placeholder="Maximum Percentage For Examination Duration"
                                    [(ngModel)]="exam.examinationDurationPercentage"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                            </div>


                            <div class="form-group">
                                <label for="noPrimaryStreamPolicy" class="label-with-info">
                                    No Primary Stream Policy
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Defines how the system reacts if the primary camera stream is unavailable.">
                                    </i>
                                </label>
                                <ng-select id="noPrimaryStreamPolicy" class="form-select"
                                    [(ngModel)]="exam.noPrimaryStreamPolicy" [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll">
                                    <ng-option value="">NotSet</ng-option>
                                    <ng-option value="Warn">Warn</ng-option>
                                    <ng-option value="Reject">Reject</ng-option>
                                </ng-select>
                            </div>
                            <div class="form-group">
                                <label for="noSecondViewStreamPolicy" class="label-with-info">
                                    No Second View Stream Policy
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Controls enforcement when the secondary camera stream is missing or disconnected.">
                                    </i>
                                </label>
                                <ng-select id="noSecondViewStreamPolicy" class="form-select"
                                    [(ngModel)]="exam.noSecondViewStreamPolicy" [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll">
                                    <ng-option value="">NotSet</ng-option>
                                    <ng-option value="Warn">Warn</ng-option>
                                    <ng-option value="Reject">Reject</ng-option>
                                </ng-select>
                            </div>
                            <div class="form-group">
                                <label for="proctorAccessCodes" class="label-with-info">
                                    Proctor Access Codes
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="System-generated codes used by proctors to securely access and manage this exam session.">
                                    </i>
                                </label>
                                <input id="proctorAccessCodes" type="text" class="form-control"
                                    placeholder="Proctor Access Codes" [(ngModel)]="exam.proctorAccessCodes"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="true">
                            </div>

                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="requireProctorStart"
                                        [disabled]="!exam.liveProctoring" [(ngModel)]="exam.requireProctorStart"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="requireProctorStart">
                                        Require Proctor Start

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Candidates cannot begin the exam until a live proctor explicitly authorizes the start.">
                                        </i>
                                    </label>

                                </div>
                            </div>

                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="skipAIPassportCheck" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.skipAIPassportCheck" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="skipAIPassportCheck">
                                        Skip AI Passport Check
                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Bypasses automated facial verification. This reduces security and should be enabled only for special cases.">
                                        </i>
                                    </label>

                                </div>
                            </div>



                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="allowExternalPrimaryWebcam" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.allowExternalPrimaryWebcam"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="allowExternalPrimaryWebcam">
                                        Allow External Primary Webcam

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Permits the use of external webcams instead of built-in cameras for the primary video stream.">
                                        </i>
                                    </label>

                                </div>
                            </div>
                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="allowExternalSecondViewWebcam" type="checkbox"
                                        class="custom-control-input" [(ngModel)]="exam.allowExternalSecondViewWebcam"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="allowExternalSecondViewWebcam">
                                        Allow External Second View Webcam

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Allows external cameras to be used for the secondary (environment) view.">
                                        </i>
                                    </label>

                                </div>
                            </div>

                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <button type="button" class="btn btn-lg btn-secondary"
                                (click)="prevTab(exam.useQuestionBank && text === 'Create'? 3 : exam.psychometricTest && text === 'Update' ? 1 : 2)">Previous</button>
                            <button type="submit" class="btn btn-lg btn-success" *ngIf="text=='Update'">Submit</button>
                            <button type="button" class="btn btn-lg btn-primary" (click)="nextTab(3)">Next</button>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="instructionsTab" role="tabpanel">
                        <!-- Instructions -->
                        <div class="form-grid">
                            <div class="form-group editor-container">
                                <label for="instructionsHTML">Instructions (HTML)</label>
                                <quill-editor #editorInstructionsHTML id="instructionsHTML"
                                    [(ngModel)]="exam.instructionsHTML" name="instructionsHTML" [disabled]="disableAll">
                                </quill-editor>
                            </div>

                            <div class="form-group editor-container">
                                <label for="postExamMessages">Post Exam Messages</label>
                                <quill-editor #editorPostExamMessages id="postExamMessages"
                                    [(ngModel)]="exam.postExamMessages" name="postExamMessages" [disabled]="disableAll">
                                </quill-editor>
                            </div>
                            <div class="form-group editor-container">
                                <label for="emailNotificationTemplate">Email Notification Template</label>
                                <quill-editor #editorEmailNotificationTemplate id="emailNotificationTemplate"
                                    [(ngModel)]="exam.emailNotificationTemplate" name="emailNotificationTemplate"
                                    [disabled]="disableAll">
                                </quill-editor>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <button type="button" class="btn btn-lg btn-secondary"
                                (click)="prevTab(4)">Previous</button>
                            <button type="submit" class="btn btn-lg btn-success" *ngIf="text=='Update'">Submit</button>
                            <button type="button" class="btn btn-lg btn-primary" (click)="nextTab(4)">Next</button>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="othersTab" role="tabpanel">
                        <!-- Others Options -->
                        <div class="form-grid">

                            <div class="form-group">
                                <label for="adminStartTime" class="label-with-info">
                                    Admin Start Date
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="The earliest date an administrator is allowed to manually start this exam. Candidates cannot start before this time.">
                                    </i>
                                </label>
                                <input id="adminStartTime" type="datetime-local" class="form-control"
                                    placeholder="End Date" [(ngModel)]="exam.adminStartTime"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                            </div>
                            <div class="form-group">
                                <label for="selfRegistrationEndDate" class="label-with-info">
                                    Self Registration End Date
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Defines the deadline after which candidates can no longer self-register for this exam.">
                                    </i>
                                </label>

                                <input id="selfRegistrationEndDate" type="datetime-local" class="form-control"
                                    placeholder="Self Registration EndDate" required
                                    [(ngModel)]="exam.selfRegistrationEndDate" [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll">
                            </div>
                            <div class="form-group">
                                <label for="examinationGroupID" class="label-with-info">
                                    Examination Group
                                    <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                        title="Used to logically group related exams for reporting, access control, or bulk configuration.">
                                    </i>
                                </label>
                                <ng-select id="examinationGroupID" class="form-control"
                                    [(ngModel)]="exam.examinationGroupID" [ngModelOptions]="{ standalone: true }">
                                    <ng-option selected value="">Select Exam Group</ng-option>
                                    <ng-option *ngFor="let examGroup of examGroupsList"
                                        [value]="examGroup.examinationGroupID">{{examGroup.examinationGroupID+" "+"(" +
                                        examGroup.name + ")"}}</ng-option>
                                </ng-select>
                            </div>
                            <div class="form-group">
                                <label for="externalExaminationID">External Examination ID</label>
                                <input id="externalExaminationID" type="text" class="form-control"
                                    placeholder="External Examination ID" [(ngModel)]="exam.externalExaminationID"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                            </div>

                            <div class="form-group">
                                <label for="subject">Subject</label>
                                <input id="subject" type="text" class="form-control" placeholder="Subject"
                                    [(ngModel)]="exam.subject" [ngModelOptions]="{ standalone: true }"
                                    [disabled]="disableAll">
                            </div>


                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="useCaptcha" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.useCaptcha" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="useCaptcha">
                                        Use Captcha

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Adds a captcha challenge during candidate actions to reduce automated or bot-driven access.">
                                        </i>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="liteMode" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.liteMode" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="liteMode">
                                        Lite Mode

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Disables non-essential features to improve performance on low-bandwidth or low-resource devices.">
                                        </i>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="allowComplaint" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.allowComplaint" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="allowComplaint">
                                        Allow Ticket

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Allows candidates to submit complaints or issues related to this exam after completion.">
                                        </i>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="showScoreWhenFinished" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.showScoreWhenFinished" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="showScoreWhenFinished">
                                        Display Exam Score After Exam

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="If enabled, candidates will immediately see their score once the exam ends.">
                                        </i>
                                    </label>

                                </div>
                            </div>
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="selfRescheduleAfter" type="checkbox" class="custom-control-input mr-1"
                                        [(ngModel)]="exam.selfRescheduleAfter" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="selfRescheduleAfter">
                                        Allow Self Reschedule After

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Allows candidates to reschedule the exam themselves after a missed or completed attempt, if policy permits.">
                                        </i>
                                    </label>

                                </div>
                            </div>

                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="selfSchedule" type="checkbox" class="custom-control-input" required
                                        [(ngModel)]="exam.selfSchedule" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="selfSchedule">
                                        Allow Self Schedule

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Enables candidates to select their own exam date and time within the allowed schedule window.">
                                        </i>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="requireAdminStart" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.requireAdminStart" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="requireAdminStart">
                                        Require Admin Start

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Candidates cannot begin the exam until an administrator explicitly starts it.">
                                        </i>
                                    </label>

                                </div>
                            </div>

                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="enforceScheduleEndTime" type="checkbox" class="custom-control-input"
                                        required [(ngModel)]="exam.enforceScheduleEndTime"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="enforceScheduleEndTime">
                                        Enforce Schedule End Time

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Automatically terminates the exam when the scheduled end time is reached, regardless of remaining time.">
                                        </i>
                                    </label>

                                </div>
                            </div>

                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="excludeFromRDSConfigCalculation" type="checkbox"
                                        class="custom-control-input" [(ngModel)]="exam.excludeFromRDSConfigCalculation"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="excludeFromRDSConfigCalculation">
                                        Exclude from RDS Config Calculation

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Excludes this exam from infrastructure sizing and RDS capacity calculations. Use with caution.">
                                        </i>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="showSubmitButtonOnEveryQuestion" type="checkbox"
                                        class="custom-control-input" [(ngModel)]="exam.showSubmitButtonOnEveryQuestion"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="showSubmitButtonOnEveryQuestion">
                                        Show Submit Button on Every Question

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Displays a submit button on each question instead of only at the end of the exam.">
                                        </i>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="mockExam" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.mockExam" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="mockExam">
                                        Mock Exam

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Marks this exam as a practice test. Results may not count toward official assessments.">
                                        </i>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input id="showQuestionList" type="checkbox" class="custom-control-input"
                                        [(ngModel)]="exam.showQuestionList" [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAll">
                                    <label class="custom-control-label" for="showQuestionList">
                                        Show Question List

                                    </label>
                                    <label class="ml-1">
                                        <i class="fa fa-info-circle info-icon" data-bs-toggle="tooltip"
                                            title="Allows candidates to view the full list of questions during the exam for easier navigation.">
                                        </i>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <button type="button" class="btn btn-lg btn-secondary"
                                (click)="prevTab(5)">Previous</button>
                            <button type="submit" class="btn btn-lg btn-success" *ngIf="text=='Update'">Submit</button>
                            <button type="button" class="btn btn-lg btn-primary" (click)="nextTab(5)">Next</button>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="scheduleTab" role="tabpanel">
                        <!-- Schedule Settings -->
                        <div class="d-flex align-items-sm-end mb-2 text-muted">
                            <mat-icon class="mat-icon-button icon-sm" svgIcon="mat:error_outline"></mat-icon>
                            <span class=" pb-0 ml-1">
                                Note: This will schedule new candidates and skip already scheduled ones.
                            </span>
                        </div>

                        <div class="form-grid">

                            <div class="form-group">
                                <label for="candidateFile">Candidate Schedule File</label>
                                <input type="file" class="form-control file-select" accept=".xlsx "
                                    (change)="onScheduleFileChange($event)" />
                            </div>

                            <div class="form-group" style="display: contents;margin-top: 20px;">
                                <div class="custom-control custom-checkbox">
                                    <input id="notifyCandidatesByEmail" type="checkbox" class="custom-control-input"
                                        (click)="populateDefaultEmailMessage($event)"
                                        [(ngModel)]="exam.notifyCandidatesByEmail"
                                        [ngModelOptions]="{ standalone: true }" [disabled]="disableAll">
                                    <label class="custom-control-label" for="notifyCandidatesByEmail">Notify Candidates
                                        By Email</label>
                                </div>
                            </div>


                        </div>
                        <div class="d-flex flex-column align-items-start">
                            <a href="/assets/templates/CandidateExaminationScheduleTemplate.xlsx" download>
                                Download Template</a>
                        </div>
                        <div class="form-grid" *ngIf="exam.notifyCandidatesByEmail">
                            <div class="form-group">
                                <label class="form-label">Message</label>
                                <quill-editor #editor [(ngModel)]="exam.emailMessage" name="message"
                                    (onEditorCreated)="onEditorReady($event)">
                                </quill-editor>
                            </div>
                            <div class="form-group">
                                <div class="mb-2">
                                    <h5>Possible Placeholder Options</h5>
                                    <p>Use the following placeholders to customize your message. <span
                                            class="text-primary">Click on the
                                            placeholder to copy it</span></p>
                                    <ul class="flex-grid">
                                        <span class="btn btn-outline-secondary placeholder-tag"
                                            (click)="copyPlaceholder('{candidate_fullname}', $event)">
                                            Candidate Fullname
                                        </span>

                                        <span class="btn btn-outline-secondary placeholder-tag"
                                            (click)="copyPlaceholder('{exam_name}', $event)">
                                            Exam Name
                                        </span>

                                        <span class="btn btn-outline-secondary placeholder-tag"
                                            (click)="copyPlaceholder('{exam_start_datetime}', $event)">
                                            Exam Start Datetime
                                        </span>

                                        <span class="btn btn-outline-secondary placeholder-tag"
                                            (click)="copyPlaceholder('{exam_end_datetime}', $event)">
                                            Exam End Datetime
                                        </span>

                                        <span class="btn btn-outline-secondary placeholder-tag"
                                            (click)="copyPlaceholder('{exam_duration}', $event)">
                                            Exam Duration
                                        </span>

                                        <span class="btn btn-outline-secondary placeholder-tag"
                                            (click)="copyPlaceholder('{schedule_start_datetime}', $event)">
                                            Schedule Start Datetime
                                        </span>

                                        <span class="btn btn-outline-secondary placeholder-tag"
                                            (click)="copyPlaceholder('{schedule_end_datetime}', $event)">
                                            Schedule End Datetime
                                        </span>


                                    </ul>

                                    <!-- Toast -->
                                    <div *ngIf="toast.visible" class="copy-toast"
                                        [ngStyle]="{ top: toast.y + 'px', left: toast.x + 'px' }">
                                        Copied and inserted!
                                    </div>

                                </div>
                            </div>

                        </div>

                        <div class="d-flex justify-content-between mt-3">
                            <button type="button" class="btn btn-lg btn-secondary"
                                (click)="prevTab(6)">Previous</button>
                            <button type="submit" class="btn btn-lg btn-success">Submit</button>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    </div>
</div>